export class BalanceRegistrationResponseEntity {
  createdAt?: string;
  updatedAt?: string;
  type?: number;
  status?: number;
  code?: string;
  name?: string;
  transRef?: string | null;
  totalAmount?: string | number;
  totalPrice?: string | number;
  description?: string;
  note?: string;
  order?: number;
  ownerId?: string;
  carrier?: string;
  phoneNumber?: string;
  partner?: string;
  partnerName?: string;
  partnerCode?: string;
  userFullName?: string;
  userPhone?: string;
  supplierRefCode?: string;
  currency?: string;
  beforeCredit?: string;
  afterCredit?: string;
  platform?: string;

  constructor(data?: Partial<BalanceRegistrationResponseEntity>) {
    Object.assign(this, data);
  }
}
